import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject, takeUntil } from 'rxjs';
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { GridApiService } from "src/app/data-grid/grid-api.service";

@Component({
  selector: "app-column-dropdown",
  templateUrl: "./column-dropdown.component.html",
  styleUrls: ["./column-dropdown.component.scss"],
})
export class ColumnDropdownComponent implements OnInit,OnDestroy {
  public columns = [];
  changesColumnState: boolean = false;
  searchedText;
  gridOptions: any;
  columnList:any;
  private destroy$ = new Subject<void>();

  constructor(
    public gridActionsService: GridActionsService,
    private gridApiService: GridApiService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ColumnDropdownComponent>,
  ) {
    this.gridApiService.changedColumnState$.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.changesColumnState = e;
    });
  }

  ngOnInit(): void {
    this.gridOptions = this.data.gridOptions;
    this.columnList = this.gridOptions.getColumns();
    if(this.data.isTrendSales){      
       this.getVisibleColumns()
    }    
    this.getColumns();
  }

  selectColumn(colId: any) {
    let isVisible;
    this.gridApiService.showNotification$.next(true);
      let column:any = this.gridOptions.getColumn(colId);
      if((column.isRowGroupActive() && (column.colId == 'date' || column.colId == 'sku' || column.colId == 'groupName' || column.colId == 'itemName' || column.colId == 'AmazonShipmentId'))
          || column.userProvidedColDef.setVisible) {
        isVisible = false;
      } else{
        isVisible = this.gridOptions
          .getColumn(colId)
          .isVisible();
        this.gridOptions.setColumnVisible(
          colId,
          !isVisible
        );
      }
  }

  setColumns(col: any){
    if(this.data.isTrendSales){           
      this.columnList.filter((res)=>{
        let field =  (res.colId != "Sku" && res.colId != "Account" && res.colId != "Active") ?  
        res.userProvidedColDef.field.substring(2):
              res.userProvidedColDef.field;         
        if(field == col.name){             
          this.selectColumn(res.colId);
        }
      })
    } else{
      this.selectColumn(col.colId);
    }
  }

  resetColumn() {
    this.gridActionsService.resetTable(this.data?.columnDefs);
    this.gridApiService.changedColumnState$.next(false);
      this.getColumns();
  }

  getColumns() {   
    if(this.data.isTrendSales){
      let keys=[];
      this.columnList.forEach(res=>{      
       let field = res.userProvidedColDef.field.substring(2);
        let index= keys.findIndex(key => key == field);
        if(index == -1) {
          keys.push(field);
          if(res.colId != "Sku" && res.colId != "Account" && res.colId != "Active") res.name=field;
          else res.name=res.userProvidedColDef.field;
        } else{
          res.name="";
        }
      })
      this.columns=this.columnList.filter(res=> res.name);
    } else{
      this.columns = this.columnList
    }
  }
  filterItem(value) {
    if (value) {
      this.columns = this.columns.filter(
        (item) =>
          (item.name ? item.name : item.userProvidedColDef.headerName
            ? item.userProvidedColDef.headerName
            : item.userProvidedColDef.field 
          )
            .toLowerCase()
            .indexOf(value.toLowerCase()) > -1
      );
    } 
    else{
      this.getColumns()
    }
  }

  getVisibleColumns() {
    let column = []
    this.gridOptions.columnModel.columnDefs.map((el) => {
      if (el.field != "Sku" && el.field != "Account" && el.field != "Active") {
        if (!el.hide && el.hasOwnProperty('hide')) {
          return column.push(el)
        } else {
          if (el.children && el.marryChildren) {
            el.children.forEach((res) => {
              if (!res.hide) {
                return column.push(res);
              }
            });
          }
        }
      } else {
        column.push(el);
      }
    });
    this.columnList = this.columnList.filter(function (obj) {
      return column.some(function (obj2) {
        return (obj.originalParent.colGroupDef.headerName == obj2.headerName || obj.userProvidedColDef.headerName == obj2.headerName);
      });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}